import React, { Component } from 'react'
import { Container, Row } from 'reactstrap'
import { inject, observer } from 'mobx-react'
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import InfiniteScroll from "react-infinite-scroll-component";
import { IconeCarregar } from '../../../comum/components/Icones';
import DetalhesDirecionamento from './DetalhesDirecionamento';
import { CollapseItemTableIndicator } from '../../../comum/components/CollapseItemTableIndicator';
import Tooltip from '../../../comum/components/Tooltip';
import Checkbox from '../../../comum/components/Checkbox';
import DirecionamentoCard from './DirecionamentoCard';
import LoadingImage from '../../../comum/components/LoadingImage';
import { HeaderTableFixed } from "../../../../utils/headerTableFixed";

@inject("store")
@observer
export default class TabelaDirecionamentoRecinto extends Component {
    
    constructor(props){
        super(props)

        this.controller = this.props.controller;

        window.addEventListener('scroll', HeaderTableFixed);
    }

    renderEmpty() {
        if(this.controller.tableMessage !== ""){
            return <span className="mensagem-filtrar">{this.controller.tableMessage}</span>
        }else if(this.controller.loadingDirec){
            return <IconeCarregar tamanho="2x" />
        }
    }

    render() {
        
        const detalhesRow = {
            renderer: row => <Row>
                <DetalhesDirecionamento controller={this.controller} row={row} />
            </Row>,
            showExpandColumn: true,
            expandByColumnOnly: true,
            expandHeaderColumnRenderer: () => "Detalhes",
            expandColumnPosition: 'right',
            expandColumnRenderer: ({ expanded }) => {
                if (expanded) {
                    return (
                        <CollapseItemTableIndicator expanded={expanded}/>
                    );
                }
                return (
                    <CollapseItemTableIndicator expanded={expanded}/>
                );
            },
        }

        const selectRow = {
            mode: 'checkbox',
            selectionHeaderRenderer: ({ indeterminate, ...rest }) => (
                <Tooltip tooltipText={`Clique aqui para ${rest.checked || indeterminate ? "desmarcar" : "selecionar"} todos os registros`}>
                    <Checkbox ativo={rest.checked} onClick={() => { }} />
                </Tooltip>
            ),
            selectionRenderer: ({ mode, ...rest }) =>
                <Checkbox ativo={rest.checked} onClick={() => { }} />,
            onSelect: (row, isSelect, rowIndex, e) => {
                e.preventDefault()
                e.stopPropagation()
                this.controller.selecionar(row)
            },
            onSelectAll: (isSelect, rows, e) => {
                e.preventDefault()
                e.stopPropagation()

                while (this.controller.hasMore) {
                    this.controller.loadNextTurn()
                }

                this.controller.selecionarTodos(rows, isSelect)
                if (isSelect) {
                    const selecao = this.controller.itens.map((item, index) => {
                        return item.DirecionamentoRaCeId
                    })
                    return selecao
                } else {
                    return []
                }
            },
        }
        
        return (
            <Container fluid className="tabela-container"> {
                this.controller.loadingDirec || this.controller.tableMessage !== ""
                ? this.renderEmpty()
                : <InfiniteScroll
                    dataLength={this.controller.itens.length}
                    next={() => this.controller.loadNextTurn()}
                    hasMore={this.controller.hasMore}
                    loader={<LoadingImage />}
                  >
                    <ToolkitProvider
                        keyField="DirecionamentoRaCeId"
                        data={[...this.controller.itens]}
                        columns={[...this.controller.colunas]}
                    >
                        {props => (
                            <div>
                                {
                                    window.innerWidth > 991
                                    ?
                                    <div id="tableHeaderFixed" className="tabela-overflow">
                                        <BootstrapTable bootstrap4
                                            striped
                                            bordered={false}
                                            //noDataIndication={() => this.controller.noData}
                                            classes="tabela tabela-layout cabotagem"
                                            expandRow={detalhesRow}
                                            selectRow={selectRow}
                                            {...props.baseProps} 
                                        />
                                    </div>
                                    :<Row>
                                        {this.controller.itens.map((direcionamento, index) => 
                                            <DirecionamentoCard 
                                                controller={this.controller}
                                                key={index}
                                                data={direcionamento}
                                                id={index}
                                                click={this.controller.selecionar}
                                                colunas={[...this.controller.colunas]}
                                                outrosDados={[...this.controller.outrosDados]}
                                                titulo={"NavioViagem"}
                                            />    
                                        )}
                                    </Row>
                                }
                            </div>
                        )}
                    </ToolkitProvider>
                </InfiniteScroll> 
            }
            </Container>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/direcionamento/recinto/components/TabelaDirecionamentoRecinto.js